import React from "react";

import {
  AROM_ASSESSMENT,
  FUNCTIONAL_REACH_ASSESSMENT,
} from "../../models/Enums";
import AdductionAbductionGif from "../../assets/images/AdductionAbductionGif.gif";
import LeftElbowGif from "../../assets/images/LeftElbowGif.gif";
import RightElbowGif from "../../assets/images/RightElbowGif.gif";
import LeftShoulderFAEGif from "../../assets/images/LeftShoulderFAEGif.gif";
import RightShoulderFAEGif from "../../assets/images/RightShoulderFAEGif.gif";
import LeftShoulderRotationGif from "../../assets/images/LeftShoulderRotationGif.gif";
import RightShoulderRotationGif from "../../assets/images/RightShoulderRotationGif.gif";
import LeftReachGif from "../../assets/images/leftReachGif.gif";
import RightReachGif from "../../assets/images/rightReachGif.gif";
import ForwardReachGif from "../../assets/images/forwardReachGif.gif";

interface Props {
  assessment: AssessmentKey | FRAssessmentKey;
}
export type AssessmentKey = keyof typeof assesmentData;
export type FRAssessmentKey = keyof typeof FRAssesmentData;

const topBarThree = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="655"
    height="49"
    viewBox="0 0 655 49"
    fill="none"
  >
    <rect
      x="0.945801"
      y="14.5"
      width="190.333"
      height="20"
      rx="8"
      fill="#802392"
    />
    <rect
      x="199.279"
      y="14.5"
      width="190.333"
      height="20"
      rx="8"
      fill="#802392"
    />
    <rect
      x="397.613"
      y="14.5"
      width="190.333"
      height="20"
      rx="8"
      fill="#802392"
    />
    <path
      d="M606.188 38.468C604.892 38.468 603.656 38.21 602.48 37.694C601.304 37.166 600.278 36.428 599.402 35.48C598.538 34.532 597.92 33.416 597.548 32.132L602.3 30.872C602.552 31.82 603.044 32.558 603.776 33.086C604.52 33.602 605.324 33.86 606.188 33.86C606.932 33.86 607.61 33.68 608.222 33.32C608.846 32.96 609.338 32.474 609.698 31.862C610.07 31.25 610.256 30.572 610.256 29.828C610.256 28.712 609.872 27.758 609.104 26.966C608.348 26.162 607.376 25.76 606.188 25.76C605.828 25.76 605.48 25.814 605.144 25.922C604.808 26.018 604.484 26.156 604.172 26.336L601.976 22.484L610.22 15.644L610.58 16.688H598.556V12.08H614.756V16.688L608.348 22.88L608.312 21.512C609.8 21.74 611.054 22.262 612.074 23.078C613.106 23.882 613.886 24.878 614.414 26.066C614.954 27.242 615.224 28.496 615.224 29.828C615.224 31.46 614.81 32.93 613.982 34.238C613.154 35.534 612.056 36.566 610.688 37.334C609.32 38.09 607.82 38.468 606.188 38.468ZM626.449 12.08H631.345L624.433 38H619.537L626.449 12.08ZM643.594 38.468C642.298 38.468 641.062 38.21 639.886 37.694C638.71 37.166 637.684 36.428 636.808 35.48C635.944 34.532 635.326 33.416 634.954 32.132L639.706 30.872C639.958 31.82 640.45 32.558 641.182 33.086C641.926 33.602 642.73 33.86 643.594 33.86C644.338 33.86 645.016 33.68 645.628 33.32C646.252 32.96 646.744 32.474 647.104 31.862C647.476 31.25 647.662 30.572 647.662 29.828C647.662 28.712 647.278 27.758 646.51 26.966C645.754 26.162 644.782 25.76 643.594 25.76C643.234 25.76 642.886 25.814 642.55 25.922C642.214 26.018 641.89 26.156 641.578 26.336L639.382 22.484L647.626 15.644L647.986 16.688H635.962V12.08H652.162V16.688L645.754 22.88L645.718 21.512C647.206 21.74 648.46 22.262 649.48 23.078C650.512 23.882 651.292 24.878 651.82 26.066C652.36 27.242 652.63 28.496 652.63 29.828C652.63 31.46 652.216 32.93 651.388 34.238C650.56 35.534 649.462 36.566 648.094 37.334C646.726 38.09 645.226 38.468 643.594 38.468Z"
      fill="#31344E"
    />
  </svg>
);

const topBarTwo = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="655"
    height="49"
    viewBox="0 0 655 49"
    fill="none"
  >
    <rect
      x="0.421875"
      y="14.5"
      width="290.5"
      height="20"
      rx="8"
      fill="#802392"
    />
    <rect
      x="298.922"
      y="14.5"
      width="290.5"
      height="20"
      rx="8"
      fill="#802392"
    />
    <path
      d="M617.291 38H599.326V34.2207L605.777 27.6992C607.078 26.3633 608.121 25.25 608.906 24.3594C609.703 23.457 610.277 22.6367 610.629 21.8984C610.992 21.1602 611.174 20.3691 611.174 19.5254C611.174 18.5059 610.887 17.7441 610.312 17.2402C609.75 16.7246 608.994 16.4668 608.045 16.4668C607.049 16.4668 606.082 16.6953 605.145 17.1523C604.207 17.6094 603.229 18.2598 602.209 19.1035L599.256 15.6055C599.994 14.9727 600.773 14.375 601.594 13.8125C602.426 13.25 603.387 12.7988 604.477 12.459C605.578 12.1074 606.896 11.9316 608.432 11.9316C610.119 11.9316 611.566 12.2363 612.773 12.8457C613.992 13.4551 614.93 14.2871 615.586 15.3418C616.242 16.3848 616.57 17.5684 616.57 18.8926C616.57 20.3105 616.289 21.6055 615.727 22.7773C615.164 23.9492 614.344 25.1094 613.266 26.2578C612.199 27.4062 610.91 28.6777 609.398 30.0723L606.094 33.1836V33.4297H617.291V38ZM633.182 12.3008L623.602 38H618.732L628.312 12.3008H633.182ZM652.764 38H634.799V34.2207L641.25 27.6992C642.551 26.3633 643.594 25.25 644.379 24.3594C645.176 23.457 645.75 22.6367 646.102 21.8984C646.465 21.1602 646.646 20.3691 646.646 19.5254C646.646 18.5059 646.359 17.7441 645.785 17.2402C645.223 16.7246 644.467 16.4668 643.518 16.4668C642.521 16.4668 641.555 16.6953 640.617 17.1523C639.68 17.6094 638.701 18.2598 637.682 19.1035L634.729 15.6055C635.467 14.9727 636.246 14.375 637.066 13.8125C637.898 13.25 638.859 12.7988 639.949 12.459C641.051 12.1074 642.369 11.9316 643.904 11.9316C645.592 11.9316 647.039 12.2363 648.246 12.8457C649.465 13.4551 650.402 14.2871 651.059 15.3418C651.715 16.3848 652.043 17.5684 652.043 18.8926C652.043 20.3105 651.762 21.6055 651.199 22.7773C650.637 23.9492 649.816 25.1094 648.738 26.2578C647.672 27.4062 646.383 28.6777 644.871 30.0723L641.566 33.1836V33.4297H652.764V38Z"
      fill="#31344E"
    />
  </svg>
);

const lowerArrows = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="677"
    height="96"
    viewBox="0 0 677 96"
    fill="none"
  >
    <path
      d="M46.8462 75.4976C48.2712 76.6826 50.2662 76.9526 51.9612 76.1576C53.6562 75.3626 54.7212 73.6676 54.7212 71.8076V23.8076C54.7212 21.9476 53.6412 20.2526 51.9612 19.4576C50.2812 18.6626 48.2862 18.9176 46.8462 20.1176L18.0462 44.1176L16.3212 45.5576V23.8076C16.3212 21.1526 14.1762 19.0076 11.5212 19.0076C8.86619 19.0076 6.72119 21.1526 6.72119 23.8076V71.8076C6.72119 74.4626 8.86619 76.6076 11.5212 76.6076C14.1762 76.6076 16.3212 74.4626 16.3212 71.8076V50.0576L18.0462 51.4976L46.8462 75.4976Z"
      fill="#802392"
    />
    <path
      d="M630.596 75.4976C629.171 76.6826 627.176 76.9526 625.481 76.1576C623.786 75.3626 622.721 73.6676 622.721 71.8076V23.8076C622.721 21.9476 623.801 20.2526 625.481 19.4576C627.161 18.6626 629.156 18.9176 630.596 20.1176L659.396 44.1176L661.121 45.5576V23.8076C661.121 21.1526 663.266 19.0076 665.921 19.0076C668.576 19.0076 670.721 21.1526 670.721 23.8076V71.8076C670.721 74.4626 668.576 76.6076 665.921 76.6076C663.266 76.6076 661.121 74.4626 661.121 71.8076V50.0576L659.396 51.4976L630.596 75.4976Z"
      fill="#D1D1D1"
    />
  </svg>
);

const assesmentData = {
  [AROM_ASSESSMENT.Shoulder_AAA]: {
    img: AdductionAbductionGif,
    main_heading: "Phase 1",
    text1: "Shoulder Abduction &",
    text2: "Adduction",
    topBar: topBarThree,
  },
  [AROM_ASSESSMENT.Left_Shoulder_FAE]: {
    img: LeftShoulderFAEGif,
    main_heading: "Phase 3: Right Arm",
    text1: "Right Shoulder Flexion &",
    text2: "Extension",
    topBar: topBarThree,
  },
  [AROM_ASSESSMENT.Right_Shoulder_FAE]: {
    img: RightShoulderFAEGif,
    main_heading: "Phase 2: Left Arm",
    text1: "Left Shoulder Flexion &",
    text2: "Extension",
    topBar: topBarThree,
  },
  [AROM_ASSESSMENT.Left_Elbow_FAE]: {
    img: LeftElbowGif,
    main_heading: "Phase 3: Right Arm",
    text1: "Right Elbow",
    text2: "Flexion & Extension",
    topBar: topBarTwo,
  },
  [AROM_ASSESSMENT.Right_Elbow_FAE]: {
    img: RightElbowGif,
    main_heading: "Phase 2: Left Arm",
    text1: "Left Elbow",
    text2: "Flexion & Extension",
    topBar: topBarTwo,
  },
  [AROM_ASSESSMENT.Left_Shoulder_IAE_Rotation]: {
    img: LeftShoulderRotationGif,
    main_heading: "Phase 3: Right Arm",
    text1: "Internal Rotation &",
    text2: "External Rotation",
    topBar: topBarTwo,
  },
  [AROM_ASSESSMENT.Right_Shoulder_IAE_Rotation]: {
    img: RightShoulderRotationGif,
    main_heading: "Phase 2: Left Arm",
    text1: "Internal Rotation &",
    text2: "External Rotation",
    topBar: topBarTwo,
  },
};

const FRAssesmentData = {
  [FUNCTIONAL_REACH_ASSESSMENT.Left_Reach]: {
    img: LeftReachGif,
    main_heading: "Phase 1: Left Reach",
    text1: "Reach left as far as you",
    text2: "can.",
    topBar: topBarThree,
  },
  [FUNCTIONAL_REACH_ASSESSMENT.Right_Reach]: {
    img: RightReachGif,
    main_heading: "Phase 2: Right Reach",
    text1: "Reach right as far as you ",
    text2: "can.",
    topBar: topBarTwo,
  },
  [FUNCTIONAL_REACH_ASSESSMENT.Forward_Reach]: {
    img: ForwardReachGif,
    main_heading: "Phase 3: Forward Reach",
    text1: "Reach forward as far as",
    text2: "you can.",
    topBar: topBarThree,
  },
};

const AromAssessmentGifModal: React.FC<Props> = ({ assessment }) => {
  return (
    <>
      <div
        className="generic-assesment-text-modal"
        style={{
          textAlign: "center",
        }}
      >
        <div className="align-center" style={{ height: "800px" }}>
          <div
            style={{
              fontSize: "64px",
              fontWeight: "700",
              lineHeight: "87.16px",
              textAlign: "center",
              marginBottom: "20px",
            }}
          >
            {sessionStorage.getItem("selectedAssesment") === "55"
              ? assesmentData[assessment as AssessmentKey].main_heading
              : FRAssesmentData[assessment as FRAssessmentKey].main_heading}
          </div>
          {sessionStorage.getItem("selectedAssesment") === "55"
            ? assesmentData[assessment as AssessmentKey].topBar
            : FRAssesmentData[assessment as FRAssessmentKey].topBar}
          <img
            style={{ width: 302, height: 387 }}
            src={
              sessionStorage.getItem("selectedAssesment") === "55"
                ? assesmentData[assessment as AssessmentKey].img
                : FRAssesmentData[assessment as FRAssessmentKey].img
            }
            alt="A description of the GIF"
          />
          <div
            style={{
              fontSize: "55px",
              fontWeight: "550",
              lineHeight: "74.9px",
              textAlign: "center",
              marginTop: "20px",
            }}
          >
            <div>
              {sessionStorage.getItem("selectedAssesment") === "55"
                ? assesmentData[assessment as AssessmentKey].text1
                : FRAssesmentData[assessment as FRAssessmentKey].text1}
            </div>
            <div>
              {sessionStorage.getItem("selectedAssesment") === "55"
                ? assesmentData[assessment as AssessmentKey].text2
                : FRAssesmentData[assessment as FRAssessmentKey].text2}
            </div>
          </div>
          {lowerArrows}
        </div>
      </div>
    </>
  );
};
export default AromAssessmentGifModal;
